<template lang="pug">
v-main
  v-container(fluid)
    v-card
      v-toolbar.elevation-0(color="white")
        v-toolbar-title Create Bank Account (PV)
      v-divider
      v-card-text
        v-form(ref="form", v-model="valid")
          v-row(no-gutters)
            v-col(cols="2") 
              v-subheader(color="black") Business Unit
                span(style="color: #d42a2a") *
            v-col(cols="10")
              v-select(
                v-model="formData.bu",
                :items="filteredBUList",
                item-title="business_unit.bu_name",
                item-value="business_unit",
                return-object,
                label="Select Business Unit",
                :rules="[rules.required]",
                required
              )
                template(v-slot:item="data")
                  v-list-item-title {{ getBUName(data.item) }}
                template(v-slot:selection="data")
                  span {{ getBUName(data.item) }}

          v-row(no-gutters)
            v-col(cols="2") 
              v-subheader(color="black") Bank
                span(style="color: #d42a2a") *
            v-col(cols="10")
              v-autocomplete(
                v-model="formData.bank",
                :items="bankList",
                item-title="text",
                item-value="_id",
                return-object,
                label="Select Bank",
                :rules="[rules.required]",
                :filter="customFilter",
                required
              )
                template(v-slot:item="data")
                  p {{ data.item.text }}

          v-row(no-gutters)
            v-col(cols="2") 
              v-subheader(color="black") Account Name
                span(style="color: #d42a2a") *
            v-col(cols="10")
              v-text-field(
                v-model="formData.account_name",
                label="Account Name",
                :rules="[rules.required]",
                required
              )

          v-row(no-gutters)
            v-col(cols="2") 
              v-subheader(color="black") Account No
                span(style="color: #d42a2a") *
            v-col(cols="10")
              v-text-field(
                v-model="formData.account_no",
                label="Account No",
                :rules="[rules.required, rules.accountNo]",
                required
              )

          v-row(no-gutters)
            v-col(cols="2") 
              v-subheader(color="black") Account Type
                span(style="color: #d42a2a") *
            v-col(cols="10")
              v-select(
                v-model="formData.account_type",
                :items="accountTypeOptions",
                label="Select Account Type",
                :rules="[rules.required]",
                required
              )

          v-row(no-gutters)
            v-col(cols="2") 
              v-subheader(color="black") Currency
                span(style="color: #d42a2a") *
            v-col(cols="10")
              v-select(
                v-model="formData.currency",
                :items="currencyOptions",
                label="Select Currency",
                :rules="[rules.required]",
                required
              )

          v-row(no-gutters)
            v-col(cols="2") 
              v-subheader(color="black") Status
            v-col(cols="10")
              v-radio-group(v-model="formData.is_active", row, disabled)
                v-radio(:label="'Active'", :value="true")
                v-radio(:label="'Non Active'", :value="false")

        v-card-actions.my-8
          v-btn.custom__padding-btn(@click="cancel") Cancel
          v-btn.custom__padding-btn(style="background-color:#006bff; color: white", @click="submit", :disabled="!valid || loading", :loading="loading") Save
</template>

<script>
import axios from "axios";

export default {
  name: "PVBankAccountCreate",
  data() {
    return {
      valid: false,
      loading: false,
      formData: {
        bu: null,
        bank: null,
        account_name: "",
        account_no: "",
        account_type: null,
        currency: null,
        is_active: false,
      },
      buList: [],
      bankList: [],
      accountTypeOptions: [],
      currencyOptions: [],
      rules: {
        required: (v) => !!v || "This field is required",
        accountNo: (v) => {
          if (!v) return true;
          return /^[a-zA-Z0-9\s\-_]+$/.test(v) || "Account number can only contain alphanumeric characters, spaces, hyphens, and underscores";
        },
      },
    };
  },
  computed: {
    filteredBUList() {
      const seen = {};
      return this.buList
        .filter(item => {
          return item.business_unit &&
                 item.business_unit.is_active === true &&
                 item.is_payment_voucher === true;
        })
        .filter(item => {
          const bu = item.business_unit || {};
          const buId = bu.id || bu._id;
          if (!buId) return false;
          if (seen[buId]) return false;
          seen[buId] = true;
          return true;
        });
    },
  },
  mounted() {
    Promise.all([
      this.loadBUList(),
      this.loadBankList(),
      this.loadAccountTypes(),
      this.loadCurrencies()
    ]);
  },
  methods: {
    loadAccountTypes() {
      const token = localStorage.getItem("token");
      return axios
        .get(`${process.env.VUE_APP_API}/pv/account-types`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          const data = res.data.data || [];
          this.accountTypeOptions = data.map(item => item.account_type);
        })
        .catch((err) => {
          this.$toasted.error("Failed to load account types", { icon: "error" });
        });
    },
    loadCurrencies() {
      const token = localStorage.getItem("token");
      return axios
        .get(`${process.env.VUE_APP_API}/ref/list-currency`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          const data = res.data || [];
          this.currencyOptions = data.map(item => item.code);
        })
        .catch((err) => {
          this.$toasted.error("Failed to load currencies", { icon: "error" });
        });
    },
    loadBUList() {
      const token = localStorage.getItem("token");
      const userData = this.$store.state.dataUsers;
      const userId = userData.user || userData;
      
      if (userId) {
        return axios
          .get(`${process.env.VUE_APP_API}/users/active/bu/${userId._id}`, {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then((res) => {
            this.buList = res.data.data || [];
          })
          .catch((err) => {
            this.$toasted.error("Failed to load business units", { icon: "error" });
          });
      }
      return Promise.resolve();
    },
    loadBankList() {
      const token = localStorage.getItem("token");
      return axios
        .get(`${process.env.VUE_APP_API}/ref/list-bank`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          this.bankList = res.data || [];
          // Sort by text (bank name) ascending
          this.bankList.sort((a, b) => {
            const nameA = a.text ? a.text.toLowerCase() : '';
            const nameB = b.text ? b.text.toLowerCase() : '';
            return nameA.localeCompare(nameB);
          });
        })
        .catch((err) => {
          this.$toasted.error("Failed to load bank list", { icon: "error" });
        });
    },
    customFilter(item, queryText, itemText) {
      const textOne = item.text ? item.text.toLowerCase() : "";
      const textTwo = item.alias ? item.alias.toLowerCase() : "";
      const searchText = queryText.toLowerCase();

      return (
        textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
      );
    },
    submit() {
      if (!this.$refs.form.validate()) return;
      
      this.loading = true;
      const token = localStorage.getItem("token");
      
      const payload = {
        bu_id: this.formData.bu.business_unit.id,
        bu_name: this.formData.bu.business_unit.bu_name,
        bank_id: this.formData.bank._id,
        bank_name: this.formData.bank.text,
        account_name: this.formData.account_name,
        account_no: this.formData.account_no,
        account_type: this.formData.account_type,
        currency: this.formData.currency,
        is_active: this.formData.is_active,
      };
      
      axios
        .post(`${process.env.VUE_APP_API}/pv/bank-accounts`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then(() => {
          this.$toasted.success("Success! Bank account has been created.", { icon: "check_circle" });
          this.$router.push({ name: "PV Bank Account List" });
        })
        .catch((err) => {
          const errorMsg = err.response && err.response.data && err.response.data.message || "Failed to create bank account";
          this.$toasted.error(errorMsg, { icon: "error" });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    cancel() {
      this.$router.push({ name: "PV Bank Account List" });
    },
    getBUName(item) {
      return item.business_unit && item.business_unit.bu_name ? item.business_unit.bu_name : '';
    },
  },
};
</script>

<style scoped>
.custom__padding-btn {
  margin-right: 0.5rem;
}
</style>
